module.exports = __webpack_public_path__ + "img/neb1-starless.c78c02e8.png";